import { ArrowSquareOut, Cube } from '@phosphor-icons/react';
import styled from 'styled-components';
import { useMemo, useState } from 'react';
import {
  HeaderText,
  HoverBorderButton,
  MuteBorder,
  MuteText,
  ShadowBox,
} from '../../../elements';
import { AllocationService, CommonUtility, theme, ToastMessage } from '../../../utility';
import { ConfirmationPopup, DarkPopup, ItemImage } from '../../../components';

const ItemsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

const TitleContainer = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;

const ToteContainer = styled.div`
  width: 80px;
`;

export function CancelledItems({ items, onCancelItem, isPallet, allItemsPacked }) {
  const [deletePopup, setDeletePopup] = useState(null);
  const [processing, setProcessing] = useState(false);

  const showPopup = allocation => {
    setDeletePopup(allocation);
  };

  const removeAllocation = async () => {
    try {
      setProcessing(true);
      await AllocationService.removeAllocationFromContainer(
        deletePopup.allocationId?._id,
      );
      ToastMessage.success('Allocation removed successfully');
      onCancelItem(deletePopup.allocationId?._id);
      setDeletePopup(null);
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setProcessing(false);
    }
  };

  const cancelledItems = useMemo(() => {
    if (CommonUtility.isValidArray(items)) {
      return items?.filter(x => x.isCancelled);
    }
    return [];
  }, [items]);

  if (!cancelledItems?.length) {
    return <></>;
  }

  return (
    <div className="d-flex mt-3">
      {allItemsPacked && <ToteContainer />}
      <div className="row w-100">
        <ShadowBox className="col-6">
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
              <Cube size={24} color={theme.colors.grey} />
              <HeaderText className="mx-1">
                Cancelled {isPallet ? 'Orders' : 'Items'}
              </HeaderText>
            </div>
          </div>
          <ItemsContainer>
            {cancelledItems?.map((item, index) => (
              <>
                <div
                  key={item._id}
                  className="d-flex align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center">
                    <ItemImage
                      imageKey="p_images"
                      displayImageKey="display_image"
                      item={item?.productId}
                      size="mini"
                    />
                    <div className="d-flex flex-column ml-2">
                      <DarkPopup
                        trigger={
                          <TitleContainer>{item?.productId?.p_title}</TitleContainer>
                        }
                      >
                        {item?.productId?.p_title}
                      </DarkPopup>
                      <div className="d-flex">
                        <MuteText>SKU</MuteText>
                        <span className="ml-2">{item?.productId?.p_sku}</span>
                      </div>
                      <div className="d-flex">
                        <MuteText>UPC</MuteText>
                        <span className="ml-2">{item?.productId?.upc}</span>
                      </div>
                    </div>
                  </div>
                  {isPallet && (
                    <div className="d-flex mx-2">
                      <MuteText className="mr-2">Order</MuteText>
                      <span>{item.order.marketplace_order_display_id}</span>
                    </div>
                  )}
                  <HoverBorderButton
                    className="flex-btn px-3"
                    onClick={() => showPopup(item)}
                  >
                    <ArrowSquareOut className="mr-1" size={17} /> Remove
                  </HoverBorderButton>
                </div>
                {index !== cancelledItems?.length - 1 && <MuteBorder />}
              </>
            ))}
          </ItemsContainer>
          <ConfirmationPopup
            open={!!deletePopup}
            onClose={() => setDeletePopup(null)}
            onConfirm={removeAllocation}
            loading={processing}
            title="Confirm Removing Item"
            message={
              isPallet
                ? `Are you sure you want to remove the item with SKU ${deletePopup?.productId?.p_sku} from order ${deletePopup?.order?.marketplace_order_display_id} in the container?`
                : `Are you sure you want to remove the item with SKU ${deletePopup?.productId?.p_sku} in the container?`
            }
          />
        </ShadowBox>
      </div>
    </div>
  );
}
